import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  return <section className="relative w-full" data-id="element-85">
      {/* Top Navy Section */}
      <div className="bg-[#1B2A4A] text-[#F5F0E8] pt-12 pb-24 px-4 md:px-8 rounded-b-[3rem]" data-id="element-86">
        <div className="max-w-3xl mx-auto text-center" data-id="element-87">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.6
        }} data-id="element-88">
            <span className="inline-block bg-[#C94040] text-white px-4 py-1 rounded-full text-sm font-bold tracking-wide mb-6" data-id="element-89">
              PARA MUJERES 65+ EN USA
            </span>

            <h1 className="font-serif text-4xl md:text-6xl font-bold mb-4 leading-tight" data-id="element-90">
              $56 Más No Te Salva
            </h1>

            <p className="text-xl md:text-2xl text-gray-300 mb-8 font-light" data-id="element-91">
              Plan Anti-Ahogos de 14 Días para que tu Cheque Rinda
            </p>

            <div className="bg-white/10 backdrop-blur-sm p-6 rounded-xl border border-white/20 mb-10" data-id="element-92">
              <p className="text-lg md:text-xl leading-relaxed" data-id="element-93">
                Un sistema simple (sin apps) para mujeres que viven con ingreso
                fijo y quieren dejar de sobrevivir en modo alarma.
              </p>
            </div>
          </motion.div>
        </div>
      </div>

      {/* Image Overlap */}
      <div className="max-w-4xl mx-auto px-4 -mt-16 mb-16 relative z-10" data-id="element-94">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        delay: 0.3,
        duration: 0.6
      }} className="flex justify-center" data-id="element-95">
          <img src="https://cdn.magicpatterns.com/uploads/3p9PnRdD9X64hadXHk1MFK/Plan_anti_ahogos.png" alt="Plan Anti-Ahogos en una mesa con facturas" className="rounded-xl shadow-2xl max-w-full md:max-w-md border-4 border-white" data-id="element-96" />
        </motion.div>
      </div>

      {/* Opening Lead - Warm Paper Background */}
      <div className="bg-[#FAF7F2] px-4 pb-16" data-id="element-97">
        <div className="max-w-2xl mx-auto" data-id="element-98">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="prose prose-lg prose-p:text-[#2D2A26] prose-p:text-lg md:prose-p:text-xl prose-p:leading-relaxed" data-id="element-99">
            <p className="font-bold text-2xl text-[#1B2A4A] mb-6" data-id="element-100">
              Hay un tipo de miedo que casi nadie dice en voz alta.
            </p>

            <p data-id="element-101">No es “no tener lujos”.</p>

            <p data-id="element-102">Es ese momento en que aparece una cuenta… y tú piensas:</p>

            <p className="italic text-[#C94040] font-medium border-l-4 border-[#C94040] pl-4 my-6" data-id="element-103">
              “Si pago esto, ¿qué no pago?”
            </p>

            <p data-id="element-104">Y lo peor es que no siempre es por un gasto grande.</p>

            <p data-id="element-105">
              A veces tu dinero se va en cosas pequeñas, repetidas, silenciosas.
            </p>

            <p data-id="element-106">Cargos. Farmacia. Comida sin lista. Suscripciones. Atrasos.</p>

            <p data-id="element-107">No es que tú seas desordenada.</p>

            <p data-id="element-108">
              Es que nadie te dio un sistema que funcione con cansancio, con
              letra grande, y sin tecnología complicada.
            </p>
          </motion.div>

          <div className="mt-12 text-center" data-id="element-109">
            <CTAButton data-id="element-110">QUIERO EL PLAN DE 14 DÍAS</CTAButton>
          </div>
        </div>
      </div>
    </section>;
}